// type of user
export const ADMIN = "ADMIN";
export const MEMBER = "MEMBER";
export const NORMAL = "NORMAL";
export const EVERYONE = "EVERYONE";
